import React from 'react';
import { Card } from '../ui/Card';
import { Trophy, Zap, Target, Flame, Star } from 'lucide-react';
interface PersonalRecordsSectionProps {
  fastestTime: number | null;
  accuracy: number;
  longestStreak: number;
  perfectSessions: number;
  dailyGoals: number;
}
export function PersonalRecordsSection({
  fastestTime,
  accuracy,
  longestStreak,
  perfectSessions,
  dailyGoals
}: PersonalRecordsSectionProps) {
  const formatTime = (ms: number) => {
    const seconds = (ms / 1000).toFixed(1);
    return `${seconds}s`;
  };
  const records = [{
    id: 'fastest',
    label: 'Snelste Antwoord',
    value: fastestTime ? formatTime(fastestTime) : '-',
    icon: Zap,
    color: 'text-amber-500',
    bg: 'bg-amber-100'
  }, {
    id: 'accuracy',
    label: 'Nauwkeurigheid',
    value: `${accuracy}%`,
    icon: Target,
    color: 'text-blue-500',
    bg: 'bg-blue-100'
  }, {
    id: 'streak',
    label: 'Langste Reeks',
    value: `${longestStreak} dgn`,
    icon: Flame,
    color: 'text-orange-500',
    bg: 'bg-orange-100'
  }, {
    id: 'perfect',
    label: 'Perfecte Sessies',
    value: perfectSessions,
    icon: Star,
    color: 'text-purple-500',
    bg: 'bg-purple-100'
  }, {
    id: 'goals',
    label: 'Dagdoelen',
    value: dailyGoals,
    icon: Trophy,
    color: 'text-emerald-500',
    bg: 'bg-emerald-100'
  }];
  return <div className="space-y-4" data-id="element-1807">
      <div className="flex items-center gap-3 px-1" data-id="element-1808">
        <div className="w-10 h-10 rounded-xl bg-indigo-100 flex items-center justify-center" data-id="element-1809">
          <Star className="w-5 h-5 text-indigo-600" data-id="element-1810" />
        </div>
        <h2 className="text-xl font-black text-slate-800" data-id="element-1811">
          Persoonlijke Records
        </h2>
      </div>

      <Card className="p-4 sm:p-6 bg-gradient-to-br from-slate-800 to-slate-900 border-2 border-slate-700 rounded-2xl shadow-lg relative overflow-hidden" data-id="element-1812">
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white opacity-5 rounded-full blur-xl pointer-events-none" data-id="element-1813" />
        <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-32 h-32 bg-indigo-500 opacity-10 rounded-full blur-2xl pointer-events-none" data-id="element-1814" />

        <div className="flex overflow-x-auto pb-2 -mb-2 sm:pb-0 sm:mb-0 gap-4 sm:gap-6 sm:justify-between snap-x scrollbar-hide relative z-10" data-id="element-1815">
          {records.map(record => <div key={record.id} className="flex flex-col items-center text-center min-w-[100px] snap-center" data-id="element-1816">
              <div className={`w-12 h-12 rounded-full ${record.bg} ${record.color} flex items-center justify-center mb-3 shadow-inner`} data-id="element-1817">
                <record.icon className="w-6 h-6" data-id="element-1818" />
              </div>
              <div className="text-xl sm:text-2xl font-black text-white mb-1" data-id="element-1819">
                {record.value}
              </div>
              <div className="text-[10px] sm:text-xs font-bold text-slate-400 uppercase tracking-wider leading-tight" data-id="element-1820">
                {record.label}
              </div>
            </div>)}
        </div>
      </Card>
    </div>;
}